// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"ebbb5ad9","368":"4ac67daa","804":"7ca311a4"}[chunkId] + ".chunk.js";
};